module.exports = __webpack_public_path__ + "static/img/PY.cea466c6.svg";